import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Card } from 'semantic-ui-react';
import FeedEvent, {
  FeedTitleAndDescription,
} from './feed-event';

const iconStyle = {
  width: 50,
  height: 50,
  float: 'left',
  marginRight: 20,
};

const ShortlistCreatedEvent = ({
  isCompact,
  messageData: {
    resource: {
      id,
      createdBy,
      createdDate,
      name,
      notes,
    },
  },
}) => (
  <FeedEvent
    isCompact={isCompact}
    actionText="added a new shortlist"
    createdBy={createdBy}
    createdDate={createdDate}
  >
    <Card
      fluid
      onClick={() => window.open(`/shortlists/${id}`, '_blank')}
    >
      <Card.Content>
        <Icon
          name="list alternate outline"
          style={iconStyle}
          size="big"
          circular
        />
        <FeedTitleAndDescription
          title={name}
          description={notes}
        />
      </Card.Content>
    </Card>

  </FeedEvent>
);

ShortlistCreatedEvent.propTypes = {
  messageData: PropTypes.object.isRequired,
  isCompact: PropTypes.bool.isRequired,
};

export default ShortlistCreatedEvent;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/card-events/shortlist-created-event.js
 **/